<template>
  <div>
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(item,i)  in items" @click="urlFn(item,i)" :key="i" :id="'adv_btn'+i">
        <img class="img1" :src="item.picUrl" style="width: 100%;display: block" alt />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
export default {
  name: "headerBody",
  data() {
    return {
      items: []
    };
  },
  props: {
    advertisingPosition: String,
    source: String
  },
  computed: {},
  filters: {},
  created() {
    this.$api
      .advertisingList({
        advertisingPosition: this.advertisingPosition
      })
      .then(res => {
        this.items = res.data.body;

        switch (this.source) {
          case "goods":
            this.items.forEach((item, index) => {
              this.$nextTick(() => {
                this.$trackFn.load("adv_btn" + index, "view_material", {
                  // 曝光 - 埋点
                  page_type: "good_list",
                  card_type: "advertisement",
                  card_position: index + 1,
                  material_id: item.id,
                  material_type: "adv_btn",
                  material_link: item.jumpUrl,
                  material_position: index + 1
                });
              });
            });
            break;

          default:
            break;
        }
      });
  },
  methods: {
    urlFn(item, i) {
      this.$trackFn.send("click_material", {
        // 点击 - 埋点
        page_type: "good_list",
        card_type: "advertisement",
        card_position: i + 1,
        material_id: item.id,
        material_type: "adv_btn",
        material_link: item.jumpUrl,
        material_position: i + 1
      });
      window.location.href = item.jumpUrl;
    }
  }
};
</script>

<style scoped>
.img1 {
  height: 268px;
  border-radius: 12px;
}
</style>
